// PKCE (RFC 7636) helpers for "Login with Salesforce".
//
// The verifier never leaves the browser until the code comes back, so an
// authorization code intercepted mid-redirect is useless on its own.
// `crypto.subtle` needs a secure context - https, or localhost in development.

const VERIFIER_BYTES = 64

const base64UrlEncode = (bytes) => {
	let binary = ''
	bytes.forEach((byte) => {
		binary += String.fromCharCode(byte)
	})

	return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

const randomBase64Url = (byteLength) => {
	const bytes = new Uint8Array(byteLength)
	window.crypto.getRandomValues(bytes)

	return base64UrlEncode(bytes)
}

// 64 random bytes -> 86 base64url chars, inside the 43-128 the spec allows.
export const generateCodeVerifier = () => randomBase64Url(VERIFIER_BYTES)

// Opaque value echoed back by Salesforce; guards the callback against CSRF.
export const generateState = () => randomBase64Url(16)

export const generateCodeChallenge = async (codeVerifier) => {
	const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier))

	return base64UrlEncode(new Uint8Array(digest))
}
